import { render, staticRenderFns } from "./MindfulBenefits.vue?vue&type=template&id=34e30476&scoped=true&"
import script from "./MindfulBenefits.vue?vue&type=script&lang=js&"
export * from "./MindfulBenefits.vue?vue&type=script&lang=js&"
import style0 from "./MindfulBenefits.vue?vue&type=style&index=0&id=34e30476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e30476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
